import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FaqSection() {
  const [activeIdx, setActiveIdx] = useState<number | null>(null);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Common questions about the VigorBuy Spreadsheet and how to use it effectively.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setActiveIdx(activeIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm md:text-base font-medium font-heading text-foreground-800 pr-4">
                  {item.question}
                </h3>
                {activeIdx === idx ? (
                  <i className="ri-subtract-line w-5 h-5 flex items-center justify-center text-foreground-500 flex-shrink-0 transition-transform duration-200"></i>
                ) : (
                  <i className="ri-add-line w-5 h-5 flex items-center justify-center text-foreground-500 flex-shrink-0 transition-transform duration-200"></i>
                )}
              </button>
              {activeIdx === idx && (
                <div className="px-5 pb-4">
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}